var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCyber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 86,
    viewBox: "0 0 71 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.8359 0V86H70.8359V0H69.8359Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5084 61H14.9609C11.5859 61 8.61594 59.875 6.20844 57.4675C3.80094 55.105 2.58594 52.2025 2.58594 48.805C2.58594 45.88 3.46344 43.27 5.21844 40.975C6.99594 38.68 9.33594 37.2175 12.1484 36.5875C13.0934 33.145 14.9609 30.355 17.7734 28.2175C20.5859 26.125 23.7809 25 27.3359 25C31.7234 25 35.4584 26.53 38.4959 29.59C41.5559 32.6275 43.0859 36.3625 43.0859 40.75C45.6734 41.0425 47.8334 42.1675 49.5209 44.125C50.9609 45.7675 51.7709 47.635 51.9959 49.75H47.4959C47.2709 48.625 46.7759 47.7025 45.9434 46.8925C44.8634 45.79 43.5359 45.25 41.9609 45.25H38.5859V40.75C38.5859 37.645 37.4609 34.99 35.3009 32.785C33.1184 30.625 30.4634 29.5 27.3359 29.5C24.2309 29.5 21.5759 30.625 19.3709 32.785C17.2109 34.99 16.0859 37.645 16.0859 40.75H14.9609C12.7784 40.75 10.9334 41.515 9.40344 43.0675C7.85094 44.5975 7.08594 46.4425 7.08594 48.625C7.08594 50.8075 7.85094 52.675 9.40344 54.25C10.9334 55.7575 12.7784 56.5 14.9609 56.5H20.5859C20.5859 58.12 20.9234 59.6275 21.5084 61ZM52.0859 54.25V58.75H47.5859V63.25H43.0859V58.75H38.1359C37.2359 61.45 34.7609 63.25 31.8359 63.25C28.0109 63.25 25.0859 60.325 25.0859 56.5C25.0859 52.675 28.0109 49.75 31.8359 49.75C34.7609 49.75 37.2359 51.55 38.1359 54.25H52.0859ZM34.0859 56.5C34.0859 55.375 33.1859 54.25 31.8359 54.25C30.4859 54.25 29.5859 55.375 29.5859 56.5C29.5859 57.625 30.4859 58.75 31.8359 58.75C33.1859 58.75 34.0859 57.625 34.0859 56.5Z",
    fill: "url(#paint0_linear_2645_4443)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2645_4443",
    x1: 2.58594,
    y1: 45.5223,
    x2: 52.5507,
    y2: 45.4411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#880000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042449"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyber);
export default __webpack_public_path__ + "static/media/cyber.6d34198e0a28418f9df9a419c3575f6e.svg";
export { ForwardRef as ReactComponent };